module.exports = __webpack_public_path__ + "static/media/banner_5.965d23de.jpg";